import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from 'html-react-parser';
import { services } from "constants/services";

function SMSNotificationAlerts() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron badgeText="Services" title={`<span className="jumbotron-subtitle-2">SMS Notifications</span> Alerts`} />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.about.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.about.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col>
              <h2>SMS Notification Alerts for Transactions</h2>
            </Col>
          </Row>
          <Row className="my-5">
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.whatIs.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.whatIs.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.transferPayment.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.transferPayment.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.purpose.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.purpose.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.serviceFee.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.serviceFee.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.sample.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.sample.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.availabilty.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.availabilty.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.smsNotificationAlerts.howToApply.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.smsNotificationAlerts.howToApply.description)}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default SMSNotificationAlerts;